<template>
  <div class="about_intro">
    <div class="about_intro_title">上市</div>
    <br>
    <p>2019年3月28日，东群教育科技正式于齐鲁股权交易中心鸣锣开盘，成功挂牌，股权代码302987，挂牌价4.8元每股。</p>
    <br>
    <div v-for="(item, index) in about_listd" key="index">
      <img :src="item.img">
      <br>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      about_listd: [
        {
          img: require("../img/about-listed (1).jpg")
        },
        {
          img: require("../img/about-listed (2).jpg")
        },
        {
          img: require("../img/about-listed (3).jpg")
        },
        {
          img: require("../img/about-listed (4).jpg")
        }
      ]
    };
  }
};
</script>

<style>
.about_intro_title {
  font-size: 20px;
  border-bottom: 1px dotted #cccccc;
  color: #00ad74;
  line-height: 40px;
}
.about_intro p {
  font-size: 14px;
  font-weight: lighter;
  text-indent: 2em;
  line-height: 28px;
}
.about_intro img {
  align-items: center;
  display: flex;
  margin: 0 auto;
  width: 500px;
}
</style>
